import EventShareSchedule from '@/screens/EventShareSchedule';

export default function PrivateEventEventIdEventsShareIndexRoute() {
  return <EventShareSchedule />;
}
